let observers = [];
let previousChildrenCount = 0;

function fadeInChildren(onlyNewItems = false) {
	const overviewItemsBlock = document.querySelector('.overview-items');
	if (!overviewItemsBlock) {
		return;
	}

	const facetwpTemplate = overviewItemsBlock.querySelector('.facetwp-template');
	if (!facetwpTemplate) {
		return;
	}

	const children = Array.from(facetwpTemplate.children);
	const currentChildrenCount = children.length;

	let itemsToFadeIn = children;
	let startIndex = 0;

	if (onlyNewItems && currentChildrenCount > previousChildrenCount) {
		// Only fade in the newly added items
		itemsToFadeIn = children.slice(previousChildrenCount);
		startIndex = previousChildrenCount;
	}

	itemsToFadeIn.forEach((child, index) => {
		child.style.opacity = '0';
		child.style.transition = 'opacity 0.4s ease-in-out';

		setTimeout(() => {
			child.style.opacity = '1';
		}, index * 150);
	});

	previousChildrenCount = currentChildrenCount;
}

function initLoadMoreAutoTrigger() {
	// Clean up existing observers
	observers.forEach((observer) => {
		observer.disconnect();
	});
	observers = [];

	const pager = typeof FWP !== 'undefined' && FWP.settings && FWP.settings.pager ? FWP.settings.pager : null;

	const loadMoreContainers = document.querySelectorAll('[data-has-load-more]');

	loadMoreContainers.forEach((container) => {
		const loadMoreButton = container.querySelector('.facetwp-load-more');

		if (!loadMoreButton) {
			return;
		}

		// Check if there are more results to load
		const hasMoreResults = pager ? pager.page < pager.total_pages : true;

		if (!hasMoreResults) {
			// No more results, hide/remove the button
			loadMoreButton.style.display = 'none';
			return;
		}

		loadMoreButton.style.display = '';

		// Create Intersection Observer to watch when button comes into view
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						loadMoreButton.click();
					}
				});
			},
			{
				rootMargin: '0px',
				threshold: 0.1,
			}
		);

		observer.observe(loadMoreButton);
		observers.push(observer);
	});
}

document.addEventListener('facetwp-loaded', () => {
	const overviewItemsBlock = document.querySelector('.overview-items');
	const facetwpTemplate = overviewItemsBlock ? overviewItemsBlock.querySelector('.facetwp-template') : null;
	const currentChildrenCount = facetwpTemplate ? facetwpTemplate.children.length : 0;

	// Check if this is a load-more action (more items than before)
	const isLoadMore = currentChildrenCount > previousChildrenCount && previousChildrenCount > 0;

	initLoadMoreAutoTrigger();
	fadeInChildren(isLoadMore);
}, { passive: true });
